"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f91 = void 0;
exports.f91 = {
    "[indo-iranian]": [
        3701
    ]
};
